import React, { useState, useEffect } from 'react';

// Converts "HH:MM" (24hr) to { hour, minute, ampm }
function to12h(value) {
  if (!value) return { hour: '', minute: '00', ampm: 'AM' };
  const [h, m] = value.split(':').map(Number);
  const ampm = h >= 12 ? 'PM' : 'AM';
  const hour = h % 12 || 12;
  return { hour: String(hour), minute: String(m).padStart(2, '0'), ampm };
}

// Converts { hour, minute, ampm } to "HH:MM" (24hr)
function to24h(hour, minute, ampm) {
  if (!hour) return '';
  let h = parseInt(hour);
  if (ampm === 'PM' && h !== 12) h += 12;
  if (ampm === 'AM' && h === 12) h = 0;
  return `${String(h).padStart(2, '0')}:${minute}`;
}

const HOURS = ['12','1','2','3','4','5','6','7','8','9','10','11'];
const MINUTES = ['00','05','10','15','20','25','30','35','40','45','50','55'];

export default function TimePicker({ value, onChange, style }) {
  const parsed = to12h(value);
  const [hour, setHour] = useState(parsed.hour);
  const [minute, setMinute] = useState(parsed.minute);
  const [ampm, setAmpm] = useState(parsed.ampm);

  // Sync if external value changes
  useEffect(() => {
    const p = to12h(value);
    setHour(p.hour);
    setMinute(p.minute);
    setAmpm(p.ampm);
  }, [value]);

  const handleChange = (newHour, newMinute, newAmpm) => {
    const val = to24h(newHour, newMinute, newAmpm);
    if (val) onChange(val);
  };

  const selectStyle = {
    padding: '0.35rem 0.25rem',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    fontSize: '0.875rem',
    background: 'white',
    cursor: 'pointer',
    outline: 'none',
    appearance: 'none',
    WebkitAppearance: 'none',
    textAlign: 'center',
    fontWeight: '600',
    color: '#111827',
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '2px', ...style }}>
      {/* Hour */}
      <select
        value={hour}
        onChange={e => { setHour(e.target.value); handleChange(e.target.value, minute, ampm); }}
        style={{ ...selectStyle, width: '46px' }}
      >
        <option value="">--</option>
        {HOURS.map(h => <option key={h} value={h}>{h}</option>)}
      </select>

      <span style={{ fontWeight: '700', color: '#6b7280', fontSize: '0.9rem' }}>:</span>

      {/* Minute */}
      <select
        value={minute}
        onChange={e => { setMinute(e.target.value); handleChange(hour, e.target.value, ampm); }}
        style={{ ...selectStyle, width: '46px' }}
      >
        {MINUTES.map(m => <option key={m} value={m}>{m}</option>)}
        {/* Also allow any minute typed manually */}
        {!MINUTES.includes(minute) && minute && <option value={minute}>{minute}</option>}
      </select>

      {/* AM/PM */}
      <select
        value={ampm}
        onChange={e => { setAmpm(e.target.value); handleChange(hour, minute, e.target.value); }}
        style={{ ...selectStyle, width: '50px', color: ampm === 'AM' ? '#4338ca' : '#b45309' }}
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
}